import { BookText, CalendarDays } from "lucide-react";
import React from "react";
import { Link, NavLink } from "react-router-dom";
// css comes in published_file.css

const ReviewAssessBoxHW = (props) => {
  const reduceParaGraph = (text, length) => {
    if (text.length < length) {
      return text;
    }
    return text.substring(0, length) + "...";
  };
  return (
    <>
      <div
        className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4"
        style={{
          backgroundColor: "#FDEFE3",
          borderTop: "2px solid #8D4B28",
          borderRight: "4px solid #8D4B28",
          borderBottom: "1px solid #8D4B28",
          borderLeft: "1px solid #8D4B28",
          borderRadius: "0.75rem",
        }}
      >
        {/* Header: Class | Section | Subject + 3 Dots */}
        <div className="d-flex justify-content-between align-items-start mb-2">
          <NavLink
            to={`/onreviewstudentlistHW`}
            state={{ homework_id: props.Homework_id }}
            className="text-dark fw-semibold text-decoration-none"
          >
            {props?.standard} – {props?.section} |{" "}
            <span title={props?.Review_subject} className="poppins-semibold">
              {reduceParaGraph(props?.Review_subject, 27)}
            </span>
          </NavLink>
        </div>

        {/* Assessment Name */}
        <NavLink
          to={`/onreviewstudentlistHW`}
          className="text-decoration-none text-dark"
          state={{ homework_id: props.Homework_id }}
        >
          <div className="d-flex align-items-center mb-1">
            <BookText size={16} className="me-2 text-dark" />
            <div
              className="text-truncate poppins-semibold"
              title={props.Review_assessName}
            >
              {props.Review_assessName}
            </div>
          </div>

          {/* Deadline */}
          <div
            className="d-flex align-items-center text-muted"
            style={{ fontSize: "0.875rem" }}
          >
            <CalendarDays size={16} className="me-2 text-dark" />
            <span>
              <span className="me-1">Deadline:</span>
              <span className=" text-dark">{props.deadline_date}</span>
            </span>
          </div>
        </NavLink>
      </div>
    </>
  );
};

export default ReviewAssessBoxHW;
